/* Fabric Fanatics — ff.js */
(function () {
  'use strict';
  function initNav(root) {
    root.querySelectorAll('[data-ff-header]').forEach(function (header) {
      var btn = header.querySelector('[data-ff-nav-toggle]');
      if (!btn || btn.dataset.ffBound) return;
      btn.dataset.ffBound = '1';
      function set(open) { btn.setAttribute('aria-expanded', open ? 'true' : 'false'); if (open) header.setAttribute('data-open', ''); else header.removeAttribute('data-open'); }
      btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
      header.addEventListener('keydown', function (e) { if (e.key === 'Escape') { set(false); btn.focus(); } });
      header.querySelectorAll('[data-ff-nav] a').forEach(function (a) { a.addEventListener('click', function () { set(false); }); });
    });
  }
  function initSticky(root) {
    root.querySelectorAll('.ff-sticky-cta').forEach(function (el) {
      if (el.parentNode !== document.body) { document.querySelectorAll('body > .ff-sticky-cta').forEach(function (old) { old.remove(); }); document.body.appendChild(el); }
    });
  }
  function initCompare(root) {
    root.querySelectorAll('[data-ff-compare]').forEach(function (el) {
      var range = el.querySelector('[data-ff-compare-range]');
      if (!range || range.dataset.ffBound) return;
      range.dataset.ffBound = '1';
      function update() { el.style.setProperty('--pos', range.value + '%'); range.setAttribute('aria-valuetext', range.value + '% before'); }
      range.addEventListener('input', update); update();
    });
  }
  /* One general quote message for every cleaning option. Customer attaches the relevant photo. */
  function initPicker(root) {
    root.querySelectorAll('[data-ff-picker]').forEach(function (picker) {
      if (picker.dataset.ffBound) return;
      picker.dataset.ffBound = '1';
      var base = picker.getAttribute('data-wa-base');
      var cta = picker.querySelector('[data-ff-picker-cta]');
      var label = picker.querySelector('[data-ff-picker-cta-label]');
      var options = picker.querySelectorAll('[data-ff-option]');
      var generalMessage = 'Hi Fabric Fanatics, I\'d like a quote please. I\'ll attach a photo of what needs cleaning.';
      options.forEach(function (opt) {
        opt.addEventListener('click', function () {
          options.forEach(function (o) { o.setAttribute('aria-pressed', o === opt ? 'true' : 'false'); });
          if (cta) cta.href = base + encodeURIComponent(generalMessage);
          if (label) label.textContent = 'Send photo for a quote';
        });
      });
      if (cta) cta.href = base + encodeURIComponent(generalMessage);
      if (label) label.textContent = 'Send photo for a quote';
    });
  }
  function init(root) { initNav(root); initSticky(root); initCompare(root); initPicker(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Scroll only changes the visual state. The header itself remains sticky. */
(function initFFHeaderScroll(){
  function bind(root){
    var headers = (root || document).querySelectorAll ? (root || document).querySelectorAll('[data-ff-header]') : [];
    headers.forEach(function(header){
      if(header.dataset.ffScrollBound) return;
      header.dataset.ffScrollBound = '1';
      function sync(){ header.classList.toggle('is-scrolled', window.scrollY > 24); }
      sync(); window.addEventListener('scroll', sync, { passive: true }); window.addEventListener('resize', sync);
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ bind(document); }); else bind(document);
  document.addEventListener('shopify:section:load', function(e){ bind(e.target); });
})();
